// 028B-2 — Curva de Crecimiento Niña de 2 meses a 5 años (corrección de
// numeración, ver PLAN.md Serie 028 — antes "028A1", código incorrecto).
import { crearFormularioCurvaCrecimiento } from './curvaCrecimiento';

export const Formulario028B2 = crearFormularioCurvaCrecimiento({ claveI18n: 'f028b2', incluirPosicionTalla: true, incluirPerimetroCefalico: true, curvasPdf: 'oms0a5' });
